import { hexStringToBuffer } from '@iotize/common/byte-converter';
import { passwordHasher } from '@iotize/tap/crypto';

import { PASSWORD_LENGTH } from './config';

export function hashLoginPassword(password: string): Uint8Array {
  return hexStringToBuffer(
    passwordHasher.hash(password).substring(0, PASSWORD_LENGTH * 2),
  );
}

export function XOR(value1: Uint8Array, value2: Uint8Array): Uint8Array {
  if (value1.length !== value2.length) {
    throw new Error(
      'Length does not match between the two array. Cannot compute XOR',
    );
  }
  const result = new Uint8Array(value1.length);
  for (let i = 0; i < result.length; i++) {
    result[i] = value1[i] ^ value2[i];
  }
  return result;
}
